import React from 'react'
import SoompiComponent from 'scripts/components/base/SoompiComponent'
import { connect } from 'scripts/store'
import { SendReaction, GetReactions } from 'scripts/lib/firebase'
import Modal from 'scripts/lib/Modal'
import Login from 'scripts/lib/firebase/login'
import locale from 'shared/i18n/react'

// assets
import heart from 'images/react01.svg'
import lol from 'images/react02.svg'
import fire from 'images/react03.svg'
import crying from 'images/react04.svg'
import omg from 'images/react05.svg'

function mapReactions(item, index) {
  return (<div key={index} className={`actions`}>
    <span className="circle actions-item">
      <a href="javascript:;" title={item.name} className={this.disabled ? 'disabled' : ''} onClick={() => this.doReaction(item.type)} >
        <img src={item.image} />
      </a>
    </span>
    <span className="actions-stats">{item.count}</span>
  </div>)
}

class Actions extends SoompiComponent {
  state = {
    id: '0',
    open: false,
    auth: false,
    alert: {title: '', message: ''},
    disabled: true,
    reactedOn: '',
    reactions: [
      { type: 'heart', name: 'Heart', image: heart, count: 0 },
      { type: 'lol', name: 'LOL', image: lol, count: 0 },
      { type: 'fire', name: 'Fire', image: fire, count: 0 },
      { type: 'crying', name: 'Crying', image: crying, count: 0 },
      { type: 'omg', name: 'OMG', image: omg, count: 0 }
    ]
  }

  componentDidMount() {
    this.resetReactions(this.props.reactions, '', '')
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.auth === 'OK') {
      this.getReactionOn(nextProps.id).then((reactedOn) => {
        this.resetReactions(nextProps.reactions, reactedOn, reactedOn)
        this.setState({disabled: false, auth: true})
      })
    } else if (nextProps.auth === 'NO') {
      this.resetReactions(nextProps.reactions, '', '')
      this.setState({disabled: false, auth: false})
    }
  }

  whatReaction = (data, type) => {
    return data && data.filter((item) => item.type === type)[0]
  }

  resetReactions = (data, reactedOn, currentReactedOn) => {
    const reactions = this.state.reactions

    reactions.map((reaction) => {
      const item = this.whatReaction(data, reaction.type)
      let count = item ? item.count : 0
      if (reaction.type === reactedOn) {
        count++
      }
      if (reaction.type === currentReactedOn) {
        count--
      }

      Object.assign(reaction, {count})
    })
    this.setState({reactions, reactedOn})
  }

  setMessage = () => {
    return (
      <React.Fragment>
        <div>{locale.reactions.dialogText}</div>
        <Login toggleWithId={() => this.setState({open: false})} />
      </React.Fragment>
    )
  }

  doReaction = (type) => {
    if (!this.state.auth) {
      this.showLoginPrompt()
      return null
    } else if (this.state.disabled || type === this.state.reactedOn) {
      return null
    }
    // disable reactions clicking
    this.setState({disabled: true})
    SendReaction(this.props.id, type, this.state.reactedOn).then(res => {
      if (res.auth === 'NO') {
        this.showLoginPrompt()
      } else if (res.errorMessage) {
        alert(res.errorMessage)
      } else {
        this.resetReactions(this.state.reactions, type, this.state.reactedOn)
      }

      this.setState({disabled: false})
    }).catch(e => {
      this.setState({disabled: false})
    })
  }

  showLoginPrompt = () => {
    this.setState({
      open: true,
      auth: false,
      alert: {
        title: locale.reactions.dialogTitle,
        message: this.setMessage()
      }
    })
  }

  getReactionOn = (id) => {
    return GetReactions(id).then(res => {
      let result = ''
      if (res && res.reactions) {
        result = res.reactions.reduce((currentReactedOn, reaction) => {
          return reaction.viewerHasReacted ? reaction.type : currentReactedOn
        }, '')
      }

      return result
    })
  }

  render() {
    return (
      <React.Fragment>
        <div className="container flex flex-center-horizontal">
          {this.state.reactions.map(mapReactions, {doReaction: this.doReaction, disabled: this.state.disabled})}
        </div>
        <Modal open={this.state.open} alert={this.state.alert} classNames={{overlay: 'modal-alert-overlay'}} closeBtn={` `} />
      </React.Fragment>
    )
  }
}

const mapStateToProps = ({auth}) => {
  return {auth}
}

export default connect(mapStateToProps)(Actions)



// WEBPACK FOOTER //
// ./assets/js/components/article/Actions.jsx